// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-result-header[data-v-2413212e]{min-height:32px;padding:8px 0}.el-icon-sort[data-v-2413212e],.el-icon-sort-down[data-v-2413212e],.el-icon-sort-up[data-v-2413212e]{align-items:center;display:inline-flex;vertical-align:middle}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
